import { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-date-pickers-pro/themeAugmentation';

export const MuiDatePicker: ThemeOptions['components']['MuiDatePicker'] = {
  defaultProps: {
    views: ['month', 'year', 'day'],
    yearsPerRow: 3
  }
};
